<template>
  <div class="profile">
    <div class="d-flex justify-content-end align-items-center mb-2">
      <Button
        :disabled="loading"
        class="btn-primary text-white"
        @click="getPdfCv"
        >Download Resume <feather-icon icon="DownloadIcon" size="16" />
      </Button>
    </div>
    <b-row v-if="Object.keys(profileData).length">
      <b-col lg="4">
        <!-- PROFILE CARD -->
        <b-card class="modern-profile-card border-0">
          <div class="profile-edit-btn">
            <router-link to="/profile/basic-info/edit">
              <button class="edit-btn">
                <feather-icon icon="EditIcon" size="16" />
              </button>
            </router-link>
          </div>

          <div class="profile-header text-center">
            <div class="profile-avatar-wrapper">
              <b-img :src="profileData.image" class="profile-avatar" />
            </div>

            <h3 class="profile-name">
              {{ profileData.name }}
            </h3>

            <p class="profile-designation">
              {{
                profileData.designation
                  ? profileData.designation
                  : "No designation added"
              }}
            </p>

            <p class="profile-bio">
              {{
                profileData.career_objective
                  ? profileData.career_objective
                  : "No career objective added yet."
              }}
            </p>
          </div>

          <!-- PREFERENCES -->
          <div class="modern-section">
            <div class="section-header">
              <h5>Preferences</h5>
              <router-link to="/profile/preference/edit">
                <button class="mini-edit-btn">
                  <feather-icon icon="EditIcon" size="14" />
                </button>
              </router-link>
            </div>

            <div class="info-grid">
              <div class="info-box">
                <span>Current Salary</span>
                <h6>
                  {{
                    profileData.current_salary
                      ? profileData.current_salary + "/-"
                      : "N/A"
                  }}
                </h6>
              </div>

              <div class="info-box">
                <span>Expected Salary</span>
                <h6>
                  {{
                    profileData.expected_salary
                      ? profileData.expected_salary + "/-"
                      : "N/A"
                  }}
                </h6>
              </div>

              <div class="info-box">
                <span>Availability</span>
                <h6>
                  {{ profileData.availability || "N/A" }}
                </h6>
              </div>

              <div class="info-box">
                <span>Workplace</span>
                <h6>
                  {{ profileData.workplace_type || "N/A" }}
                </h6>
              </div>
              <div class="info-box">
                <span>Seniority</span>
                <h6>
                  {{ profileData.seniority || "N/A" }}
                </h6>
              </div>
            </div>
          </div>

          <!-- INDUSTRIES -->
          <div class="modern-section">
            <div class="section-header">
              <h5>Industries</h5>
            </div>

            <div class="industry-wrapper">
              <span
                class="industry-badge"
                v-for="(industry, index) in profileData.industries"
                :key="index"
              >
                {{ industry.name }}
              </span>
            </div>
          </div>

          <!-- SKILLS -->
          <div class="modern-section">
            <div class="section-header">
              <h5>Skills</h5>

              <router-link to="/profile/skill/edit">
                <button class="mini-edit-btn">
                  <feather-icon icon="EditIcon" size="14" />
                </button>
              </router-link>
            </div>

            <!-- HARD SKILLS -->
            <div v-if="profileData.hard_skills.length">
              <p class="skill-title">Hard Skills</p>
              <div class="soft-skill-wrapper">
                <span
                  class="soft-skill-badge"
                  v-for="(skill, index) in profileData.hard_skills"
                  :key="index"
                >
                  {{ skill.name }}
                </span>
              </div>
            </div>

            <!-- SOFT SKILLS -->
            <div v-if="profileData.soft_skills.length" class="mt-2">
              <p class="skill-title">Soft Skills</p>

              <div class="soft-skill-wrapper">
                <span
                  class="soft-skill-badge"
                  v-for="(skill, index) in profileData.soft_skills"
                  :key="index"
                >
                  {{ skill.name }}
                </span>
              </div>
            </div>
            <!-- software_knowledge  -->
            <div v-if="profileData.software_knowledge.length" class="mt-2">
              <p class="skill-title">Software Knowladge</p>

              <div class="soft-skill-wrapper">
                <span
                  class="soft-skill-badge"
                  v-for="(skill, index) in profileData.software_knowledge"
                  :key="index"
                >
                  {{ skill.name }}
                </span>
              </div>
            </div>
          </div>

          <!-- LANGUAGES -->
          <div class="modern-section">
            <div class="section-header">
              <h5>Languages</h5>

              <router-link to="/profile/language/edit">
                <button class="mini-edit-btn">
                  <feather-icon icon="EditIcon" size="14" />
                </button>
              </router-link>
            </div>

            <div
              class="language-item"
              v-for="(lang, index) in profileData.languages"
              :key="index"
            >
              <div class="d-flex justify-content-between align-items-center">
                <span>{{ lang.language }}</span>

                <div class="language-dots">
                  <span
                    v-for="n in 5"
                    :key="n"
                    :class="n <= lang.proficiency_level ? 'dot active' : 'dot'"
                  ></span>
                </div>
              </div>
            </div>
          </div>

          <!-- URLS -->
          <div class="modern-section">
            <div class="section-header">
              <h5>Portfolio/Social Links</h5>

              <router-link to="/profile/url/edit">
                <button class="mini-edit-btn">
                  <feather-icon icon="EditIcon" size="14" />
                </button>
              </router-link>
            </div>

            <a
              v-for="(url, index) in profileData.candidate_urls"
              :key="index"
              :href="url.url"
              target="_blank"
              class="social-link"
            >
              <span>{{ url.name }}</span>

              <feather-icon icon="ArrowUpRightIcon" size="14" />
            </a>
          </div>
          <!-- REFERENCES -->
          <div class="modern-section">
            <div class="section-header">
              <h5>References</h5>

              <router-link to="/profile/reference/edit">
                <button class="mini-edit-btn">
                  <feather-icon icon="EditIcon" size="14" />
                </button>
              </router-link>
            </div>

            <div
              v-for="(reference, index) in references"
              :key="index"
              class="reference-card"
            >
              <div class="reference-top">
                <div class="reference-info">
                  <h6>
                    {{ reference.name }}
                  </h6>

                  <p class="designation">
                    {{ reference.designation }}
                  </p>

                  <small>
                    {{ reference.company }}
                  </small>
                </div>
              </div>

              <div class="reference-contact">
                <div v-if="reference.email" class="reference-contact-item">
                  <feather-icon icon="MailIcon" size="14" />

                  <span>{{ reference.email }}</span>
                </div>

                <div v-if="reference.number" class="reference-contact-item">
                  <feather-icon icon="PhoneIcon" size="14" />

                  <span>{{ reference.number }}</span>
                </div>
              </div>
            </div>

            <div v-if="!references.length" class="empty-reference">
              No references added yet.
            </div>
          </div>
        </b-card>
      </b-col>

      <b-col lg="8">
        <b-card class="modern-info-card border-0">
          <!-- HEADER -->
          <div class="modern-card-header">
            <div>
              <h4 class="modern-card-title">Basic Information</h4>

              <p class="modern-card-subtitle">Personal and contact details</p>
            </div>

            <router-link to="/profile/basic-info/edit">
              <button class="mini-edit-btn">
                <feather-icon icon="EditIcon" size="16" />
              </button>
            </router-link>
          </div>

          <!-- TOP STATUS -->
          <div class="profile-status-bar">
            <div class="status-item">
              <span>Onboarding Status</span>

              <div
                class="status-badge"
                :class="
                  profileData.onboard_status == 1
                    ? 'status-success'
                    : 'status-danger'
                "
              >
                <span class="status-dot"></span>

                {{
                  profileData.onboard_status == 1 ? "Completed" : "Incomplete"
                }}
              </div>
            </div>

            <div class="status-item">
              <span>Nationality</span>

              <h6>
                {{ profileData.nationality ? profileData.nationality : "N/A" }}
              </h6>
            </div>
          </div>

          <!-- INFORMATION GRID -->
          <div class="modern-info-grid">
            <!-- FATHER -->
            <div class="modern-info-box">
              <div>
                <span>Father Name</span>

                <h6>
                  {{
                    profileData.father_name
                      ? profileData.father_name
                      : "Not provided"
                  }}
                </h6>
              </div>
            </div>

            <!-- MOTHER -->
            <div class="modern-info-box">
              <div>
                <span>Mother Name</span>

                <h6>
                  {{
                    profileData.mother_name
                      ? profileData.mother_name
                      : "Not provided"
                  }}
                </h6>
              </div>
            </div>
            <!-- PHONE -->
            <div class="modern-info-box">
              <div>
                <span>Phone</span>

                <h6>
                  {{ profileData.phone ? profileData.phone : "Not provided" }}
                </h6>
              </div>
            </div>

            <!-- EMAIL -->
            <div class="modern-info-box">
              <div>
                <span>Email</span>

                <h6>
                  {{ profileData.email ? profileData.email : "Not provided" }}
                </h6>
              </div>
            </div>

            <!-- GENDER -->
            <div class="modern-info-box">
              <div>
                <span>Gender</span>

                <h6>
                  {{ profileData.gender ? profileData.gender : "Not provided" }}
                </h6>
              </div>
            </div>

            <!-- DOB -->
            <div class="modern-info-box">
              <div>
                <span>Date of Birth</span>

                <h6>
                  {{
                    profileData.birth_date
                      ? profileData.birth_date
                      : "Not provided"
                  }}
                </h6>
              </div>
            </div>

            <!-- SECONDARY PHONE -->
            <div class="modern-info-box">
              <div>
                <span>Secondary Phone</span>

                <h6>
                  {{
                    profileData.secondary_phone
                      ? profileData.secondary_phone
                      : "Not provided"
                  }}
                </h6>
              </div>
            </div>

            <!-- SECONDARY EMAIL -->
            <div class="modern-info-box">
              <div>
                <span>Secondary Email</span>

                <h6>
                  {{
                    profileData.secondary_email
                      ? profileData.secondary_email
                      : "Not provided"
                  }}
                </h6>
              </div>
            </div>

            <!-- MARITAL STATUS -->
            <div class="modern-info-box">
              <div>
                <span>Marital Status</span>

                <h6>
                  {{
                    profileData.marital_status
                      ? profileData.marital_status
                      : "Not provided"
                  }}
                </h6>
              </div>
            </div>

            <!-- RELIGION -->
            <div class="modern-info-box">
              <div>
                <span>Religion</span>

                <h6>
                  {{
                    profileData.religion ? profileData.religion : "Not provided"
                  }}
                </h6>
              </div>
            </div>

            <!-- BLOOD GROUP -->
            <div class="modern-info-box">
              <div>
                <span>Blood Group</span>

                <h6>
                  {{
                    profileData.blood_group
                      ? profileData.blood_group
                      : "Not provided"
                  }}
                </h6>
              </div>
            </div>

            <!-- NID -->
            <div class="modern-info-box">
              <div>
                <span>NID</span>

                <h6>
                  {{ profileData.nid ? profileData.nid : "Not provided" }}
                </h6>
              </div>
            </div>

            <!-- PASSPORT -->
            <div class="modern-info-box">
              <div>
                <span>Passport</span>

                <h6>
                  {{
                    profileData.passport_number
                      ? profileData.passport_number
                      : "Not provided"
                  }}
                </h6>
              </div>
            </div>
          </div>

          <!-- ADDRESS -->
          <div
            v-if="profileData.addresses && profileData.addresses.length"
            class="address-section"
          >
            <div class="section-divider">
              <span>Addresses</span>
            </div>

            <div class="address-grid">
              <div
                v-for="(address, index) in profileData.addresses"
                :key="index"
                class="address-card"
              >
                <div class="d-flex align-items-center mb-2">
                  <div class="address-icon">
                    <feather-icon icon="MapPinIcon" size="16" />
                  </div>

                  <h6 class="mb-0 ml-1">
                    {{ address.title }}
                  </h6>
                </div>

                <p class="mb-0">
                  {{ address.address || "" }}
                  {{ address.upazila_name || "" }}
                  {{ address.district_name || "" }}
                </p>
              </div>
            </div>
          </div>
        </b-card>

        <b-card class="modern-experience-card border-0">
          <!-- HEADER -->
          <div class="modern-card-header">
            <div>
              <h4 class="modern-card-title">Work Experience</h4>

              <p class="modern-card-subtitle">
                Professional journey and career history
              </p>
            </div>

            <router-link to="/profile/experience/edit">
              <button class="mini-edit-btn">
                <feather-icon icon="EditIcon" size="16" />
              </button>
            </router-link>
          </div>

          <!-- EXPERIENCE LIST -->
          <div
            v-if="
              profileData.experiences &&
              profileData.experiences.length &&
              profileData.experiences[0].company_name
            "
            class="experience-wrapper"
          >
            <div
              v-for="(experience, index) in profileData.experiences"
              :key="index"
              class="experience-item"
            >
              <!-- TIMELINE -->
              <div class="timeline-column">
                <div class="timeline-dot"></div>

                <div
                  v-if="index !== profileData.experiences.length - 1"
                  class="timeline-line"
                ></div>
              </div>

              <!-- CONTENT -->
              <div class="experience-content">
                <!-- TOP -->
                <div class="experience-top">
                  <div class="company-info">
                    <div>
                      <h5 class="designation">
                        {{ experience.designation }}
                      </h5>

                      <h6 class="company-name">
                        {{ experience.company_name }}
                      </h6>
                    </div>
                  </div>

                  <div v-if="experience.duration" class="duration-badge">
                    {{ experience.duration }}
                  </div>
                </div>

                <!-- DATE -->
                <div class="experience-date">
                  <feather-icon icon="CalendarIcon" size="14" class="mr-1" />

                  <span>
                    {{ experience.starting_date }}
                    -
                    {{
                      experience.ending_date
                        ? experience.ending_date
                        : "Present"
                    }}
                  </span>
                </div>

                <!-- DESCRIPTION -->
                <div
                  v-if="experience.job_description"
                  class="experience-description"
                  v-html="experience.job_description"
                ></div>
              </div>
            </div>
          </div>

          <!-- EMPTY -->
          <div v-else class="empty-experience">
            <div class="empty-icon">
              <feather-icon icon="BriefcaseIcon" size="30" />
            </div>

            <h5>No Experience Added</h5>

            <p>
              Add your professional experience to make your profile stronger.
            </p>
          </div>
        </b-card>

        <b-card class="modern-achievement-card border-0">
          <!-- HEADER -->
          <div class="modern-card-header">
            <div>
              <h4 class="modern-card-title">Achievements</h4>

              <p class="modern-card-subtitle">Highlights and accomplishments</p>
            </div>

            <router-link to="/profile/achievement/edit">
              <button class="mini-edit-btn">
                <feather-icon icon="EditIcon" size="16" />
              </button>
            </router-link>
          </div>

          <!-- LIST -->
          <div
            v-if="
              profileData.achievements &&
              Array.isArray(profileData.achievements.achievements) &&
              profileData.achievements.achievements.length
            "
          >
            <ul class="achievement-list">
              <li
                v-for="(achievement, index) in profileData.achievements
                  .achievements"
                :key="index"
              >
                {{ achievement }}
              </li>
            </ul>
          </div>

          <!-- EMPTY -->
          <div v-else class="text-center py-2">
            <small class="text-muted"> No achievements added </small>
          </div>
        </b-card>

        <b-card class="modern-education-card border-0">
          <!-- HEADER -->
          <div class="modern-card-header">
            <div>
              <h4 class="modern-card-title">Education</h4>

              <p class="modern-card-subtitle">
                Academic qualifications and educational background
              </p>
            </div>

            <router-link to="/profile/education/edit">
              <button class="mini-edit-btn">
                <feather-icon icon="EditIcon" size="16" />
              </button>
            </router-link>
          </div>

          <!-- EDUCATION GRID -->
          <div
            v-if="profileData.educations && profileData.educations.length"
            class="education-grid"
          >
            <div
              v-for="(education, index) in profileData.educations"
              :key="index"
              class="education-item"
            >
              <!-- TOP -->
              <div class="education-top">
                <div v-if="education.is_running" class="running-badge">
                  Running
                </div>
              </div>

              <!-- INSTITUTE -->
              <h5 class="education-institute">
                {{ education.institute }}
              </h5>

              <!-- DEGREE -->
              <div
                v-if="education.degree || education.subject"
                class="education-degree"
              >
                <span v-if="education.degree">
                  {{ education.degree }}
                </span>

                <span v-if="education.subject" class="education-subject">
                  in {{ education.subject }}
                </span>
              </div>

              <!-- INFO -->
              <div class="education-meta">
                <!-- GPA -->
                <div v-if="education.gpa" class="meta-item">
                  <div class="meta-icon">
                    <feather-icon icon="AwardIcon" size="14" />
                  </div>

                  <span>
                    GPA / CGPA :
                    <b>{{ education.gpa }}</b>
                  </span>
                </div>

                <!-- BOARD -->
                <div v-if="education.board" class="meta-item">
                  <div class="meta-icon">
                    <feather-icon icon="LayersIcon" size="14" />
                  </div>

                  <span>
                    Board :
                    <b>{{ education.board }}</b>
                  </span>
                </div>

                <!-- DATE -->
                <div class="meta-item">
                  <div class="meta-icon">
                    <feather-icon icon="CalendarIcon" size="14" />
                  </div>

                  <span>
                    {{ education.starting_date }}
                    -
                    {{
                      education.ending_date ? education.ending_date : "Present"
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- EMPTY -->
          <div v-else class="empty-education">
            <div class="empty-education-icon">
              <feather-icon icon="BookOpenIcon" size="34" />
            </div>

            <h5>No Education Added</h5>

            <p>
              Add your educational background to strengthen your professional
              profile.
            </p>
          </div>
        </b-card>

        <b-card class="modern-training-card border-0">
          <!-- HEADER -->
          <div class="modern-card-header">
            <div>
              <h4 class="modern-card-title">Training & Certifications</h4>

              <p class="modern-card-subtitle">
                Courses, certifications and professional learning
              </p>
            </div>

            <router-link to="/profile/training-certification/edit">
              <button class="mini-edit-btn">
                <feather-icon icon="EditIcon" size="16" />
              </button>
            </router-link>
          </div>

          <!-- TRAINING GRID -->
          <b-row
            v-if="
              profileData.training_certifications &&
              profileData.training_certifications.length
            "
          >
            <b-col
              cols="12"
              md="6"
              lg="6"
              v-for="(training, index) in profileData.training_certifications"
              :key="index"
              class="mb-3"
            >
              <div class="training-item h-100">
                <!-- TOP -->
                <div class="training-top">
                  <div v-if="training.is_running" class="running-badge">
                    Running
                  </div>
                </div>

                <!-- INSTITUTE -->
                <h5 class="training-institute">
                  {{ training.institution }}
                </h5>

                <!-- COURSE -->
                <div v-if="training.course_name" class="training-course">
                  {{ training.course_name }}
                </div>

                <!-- DETAILS -->
                <div class="training-meta">
                  <!-- TOPIC -->
                  <div v-if="training.topic" class="meta-item">
                    <div class="meta-icon">
                      <feather-icon icon="BookIcon" size="14" />
                    </div>

                    <div>
                      <small>Topic</small>

                      <h6>
                        {{ training.topic }}
                      </h6>
                    </div>
                  </div>

                  <!-- DURATION -->
                  <div v-if="training.duration" class="meta-item">
                    <div class="meta-icon">
                      <feather-icon icon="ClockIcon" size="14" />
                    </div>

                    <div>
                      <small>Duration</small>

                      <h6>
                        {{ training.duration }}
                      </h6>
                    </div>
                  </div>

                  <!-- DATE -->
                  <div class="meta-item">
                    <div class="meta-icon">
                      <feather-icon icon="CalendarIcon" size="14" />
                    </div>

                    <div>
                      <small>Timeline</small>

                      <h6>
                        {{ training.starting_date }}
                        -
                        {{
                          training.ending_date
                            ? training.ending_date
                            : "Present"
                        }}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <!-- EMPTY -->
          <div v-else class="empty-training">
            <div class="empty-training-icon">
              <feather-icon icon="AwardIcon" size="34" />
            </div>

            <h5>No Training Added</h5>

            <p>
              Add your certifications and training programs to enhance your
              profile.
            </p>
          </div>
        </b-card>
        <b-card class="modern-portfolio-card border-0 mb-2">
          <!-- HEADER -->
          <div class="modern-card-header">
            <div>
              <h4 class="modern-card-title">Portfolio Projects</h4>

              <p class="modern-card-subtitle">
                Showcase of projects, products and work samples
              </p>
            </div>

            <router-link to="/portfolio-project">
              <button class="mini-edit-btn">
                <feather-icon icon="EditIcon" size="16" />
              </button>
            </router-link>
          </div>

          <!-- PROJECT LIST -->
          <div v-if="portfolioProjects && portfolioProjects.length">
            <div
              v-for="(project, index) in portfolioProjects"
              :key="index"
              class="portfolio-project-item"
            >
              <!-- TOP -->
              <div class="portfolio-top">
                <!-- LEFT -->
                <div class="portfolio-left">
                  <div>
                    <h4 class="portfolio-title">
                      {{ project.title }}
                    </h4>

                    <p v-if="project.description" class="portfolio-subtitle">
                      {{ project.description }}
                    </p>
                  </div>
                </div>

                <!-- STATUS -->
                <div class="portfolio-status">Active Project</div>
              </div>

              <!-- DATE -->
              <div v-if="project.starting_date" class="portfolio-date">
                <feather-icon icon="CalendarIcon" size="14" class="mr-1" />

                <span>
                  {{ project.starting_date }}
                  -
                  {{ project.ending_date ? project.ending_date : "Running" }}
                </span>
              </div>

              <!-- LINK -->
              <div v-if="project.link" class="portfolio-link-wrapper">
                <a
                  :href="project.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="portfolio-link"
                >
                  <feather-icon icon="LinkIcon" size="15" class="mr-1" />

                  {{ project.link }}
                </a>
              </div>

              <!-- DESCRIPTION -->
              <div
                v-if="project.short_description"
                class="portfolio-description"
                v-html="project.short_description"
              ></div>
            </div>
          </div>

          <!-- EMPTY -->
          <div v-else class="empty-portfolio">
            <div class="empty-portfolio-icon">
              <feather-icon icon="FolderIcon" size="34" />
            </div>

            <h5>No Portfolio Projects</h5>

            <p>
              Add portfolio projects to showcase your skills and professional
              work.
            </p>
          </div>
        </b-card>
        <b-card class="modern-curriculum-card border-0">
          <!-- HEADER -->
          <div class="modern-card-header">
            <div>
              <h4 class="modern-card-title">Curriculum Activities</h4>

              <p class="modern-card-subtitle">
                Leadership, participation and student activities
              </p>
            </div>

            <router-link to="/profile/curriculum-activities/edit">
              <button class="mini-edit-btn">
                <feather-icon icon="EditIcon" size="16" />
              </button>
            </router-link>
          </div>

          <!-- ACTIVITY GRID -->
          <b-row
            v-if="
              profileData.curricular_activities &&
              profileData.curricular_activities.length
            "
            class="mx-n1"
          >
            <b-col
              v-for="(activity, index) in profileData.curricular_activities"
              :key="index"
              :cols="activity.type === 'Extra-curricular activities' ? 12 : 6"
              :md="activity.type === 'Extra-curricular activities' ? 6 : 4"
              :lg="activity.type === 'Extra-curricular activities' ? 6 : 3"
              class="px-1 mb-2"
            >
              <div class="curriculum-card-item h-100">
                <!-- TOP -->
                <div class="curriculum-card-top">
                  <div
                    class="curriculum-type-badge"
                    :class="
                      activity.type === 'Extra-curricular activities'
                        ? 'badge-extra'
                        : 'badge-co'
                    "
                  >
                    {{ activity.type }}
                  </div>
                </div>

                <!-- TITLE -->
                <h4 class="curriculum-card-title-text">
                  {{ activity.title }}
                </h4>

                <!-- DATE -->
                <div v-if="activity.starting_date" class="curriculum-date-box">
                  <feather-icon icon="CalendarIcon" size="12" class="mr-1" />

                  <span>
                    {{ activity.starting_date }}
                    -
                    {{
                      activity.ending_date
                        ? activity.ending_date
                        : activity.running
                    }}
                  </span>
                </div>

                <!-- DESCRIPTION -->
                <div
                  v-if="activity.description"
                  class="curriculum-description-box"
                  v-html="activity.description"
                ></div>
              </div>
            </b-col>
          </b-row>
          <!-- EMPTY -->
          <div v-else class="empty-curriculum">
            <div class="empty-curriculum-icon">
              <feather-icon icon="ActivityIcon" size="34" />
            </div>

            <h5>No Curriculum Activities</h5>

            <p>
              Add your activities and participation experience to enrich your
              profile.
            </p>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-end align-items-center mb-2">
      <Button
        :disabled="loading"
        class="btn-primary text-white"
        @click="getPdfCv"
        >Download Resume <feather-icon icon="DownloadIcon" size="16" />
      </Button>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardTitle,
  BCardSubTitle,
  BImg,
  BForm,
  BButton,
  BBadge,
} from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BCardSubTitle,
    BImg,
    BForm,
    BButton,
    BBadge,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      profileData: [],
      cvDowloadStatus: 1,
      references: [],
      portfolioProjects: [],
      loading: false,
    };
  },
  mounted() {
    this.getProfile();
    this.getReference();
    this.getPortfolio();
  },
  methods: {
    getPdfCv() {
      this.loading = true;
      axios
        .get(
          "/candidate/cv-export/" +
            this.profileData.id +
            "/" +
            this.cvDowloadStatus,
          {
            responseType: "blob",
          },
        )
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "Resume of " + this.profileData.name + ".pdf";
          a.click();
          window.URL.revokeObjectURL(url);
          this.loading = false;
        })
        .catch((e) => {
          this.e(e.response.data.error);
          this.loading = false;
        });
    },
    getPortfolio() {
      axios
        .get("/candidate/portfolio")
        .then((res) => {
          this.portfolioProjects = res.data.data;
        })
        .catch((e) => {
          this.e(e.data.error);
        });
    },
    getProfile() {
      axios
        .get("/candidate/profile")
        .then((res) => {
          this.profileData = res.data.data;
        })
        .catch((e) => {
          this.e(e.response.data.error);
        });
    },
    getReference() {
      axios
        .get("/candidate/reference")
        .then((res) => {
          this.references = res.data.references;
        })
        .catch((e) => {
          this.e(e.response.data.error);
        });
    },
  },
  computed: {
    sortedSkills() {
      const proficiencyOrder = {
        EXPERT: 0,
        EXPERIENCED: 1,
        ADVANCED: 2,
        BEGINNER: 3,
      };
      return this.profileData?.skills?.slice().sort((a, b) => {
        return (
          proficiencyOrder[a.proficiency] - proficiencyOrder[b.proficiency]
        );
      });
    },
  },
};
</script>

<style scoped>
.profile .profile-img img {
  width: 200px;
  height: 200px;
  border-radius: 50%;
}
.profile .profile-skills .skill,
.industries {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}
.experience-card {
  background-color: #fafafa;
}

.designation {
  color: #0c389f;
}

.highlight {
  background: #4ec76e;
  padding: 10px 20px;
  border-radius: 10px;
  color: #fff;
}
.cv h3 {
  color: #fff !important;
}

.info_inner {
  margin-bottom: 5px;
}
.info_inner .title {
  margin-bottom: 2px;
  color: #979797;
  font-weight: 450;
  text-transform: uppercase;
}
.experience-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #000;
  border-radius: 50%;
}
.experience-logo h2 {
  text-transform: uppercase;
  font-weight: bold;
  color: #ffff;
}
.modern-profile-card {
  border-radius: 24px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.08);
  position: relative;
}

.profile-cover {
  height: 120px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
}

.profile-edit-btn {
  position: absolute;
  top: 20px;
  right: 20px;
}

.edit-btn,
.mini-edit-btn {
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  color: rgb(20, 58, 196);
  transition: 0.3s;
}

.edit-btn:hover,
.mini-edit-btn:hover {
  transform: translateY(-2px);
}

.profile-avatar-wrapper {
  display: flex;
  justify-content: center;
}

.profile-avatar {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  object-fit: cover;
  border: 5px solid white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.profile-name {
  font-weight: 700;
  margin-top: 18px;
  margin-bottom: 6px;
  color: #111827;
}

.profile-designation {
  color: #6366f1;
  font-weight: 600;
  margin-bottom: 12px;
}

.profile-bio {
  color: #6b7280;
  font-size: 14px;
  line-height: 1.7;
  text-align: justify;
}

.profile-badges {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.custom-badge {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  padding: 7px 14px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 600;
}

.custom-badge.light {
  background: #eef2ff;
  color: #6366f1;
}

.modern-section {
  padding: 22px 10px;
  border-top: 1px solid #f1f5f9;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.section-header h5 {
  font-weight: 700;
  margin: 0;
  color: #111827;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.info-box {
  background: #f8fafc;
  border-radius: 16px;
  padding: 14px;
}

.info-box span {
  font-size: 12px;
  color: #94a3b8;
}

.info-box h6 {
  margin-top: 6px;
  margin-bottom: 0;
  font-weight: 700;
  color: #0f172a;
}

.industry-wrapper,
.soft-skill-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.industry-badge,
.soft-skill-badge {
  background: #f1f5f9;
  color: #334155;
  padding: 8px 14px;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 600;
}

.skill-title {
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 14px;
}

.skill-item {
  margin-bottom: 16px;
}

.skill-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.skill-top span {
  font-weight: 600;
}

.skill-progress {
  height: 8px;
  background: #e2e8f0;
  border-radius: 30px;
  overflow: hidden;
}

.skill-fill {
  height: 100%;
  border-radius: 30px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
}

.language-item {
  margin-bottom: 14px;
}

.language-dots {
  display: flex;
  gap: 6px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #cbd5e1;
}

.dot.active {
  background: #6366f1;
}

.social-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-radius: 14px;
  background: #f8fafc;
  margin-bottom: 10px;
  text-decoration: none;
  color: #111827;
  transition: 0.3s;
}

.social-link:hover {
  background: #eef2ff;
  transform: translateY(-2px);
}
.reference-card {
  background: #f8fafc;
  border-radius: 20px;
  padding: 18px;
  margin-bottom: 16px;
  transition: all 0.3s ease;
  border: 1px solid #eef2f7;
}

.reference-top {
  display: flex;
  align-items: center;
}

.reference-avatar {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  margin-right: 14px;
  flex-shrink: 0;
}

.reference-info h6 {
  margin-bottom: 4px;
  font-weight: 700;
  color: #111827;
}

.reference-info .designation {
  margin-bottom: 2px;
  color: #6366f1;
  font-size: 14px;
  font-weight: 600;
}

.reference-info small {
  color: #64748b;
  font-size: 13px;
}

.reference-contact {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #e2e8f0;
}

.reference-contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  color: #475569;
  font-size: 14px;
}

.reference-contact-item svg {
  margin-right: 10px;
  color: #6366f1;
}

.empty-reference {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
}
.modern-info-card {
  border-radius: 26px;
  padding: 10px;
  background: #ffffff;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.06);
}

.modern-card-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 28px;
}

.modern-card-title {
  font-weight: 700;
  margin-bottom: 4px;
  color: #0f172a;
}

.modern-card-subtitle {
  color: #94a3b8;
  margin-bottom: 0;
  font-size: 14px;
}

.modern-edit-btn {
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  transition: all 0.3s ease;
}

.modern-edit-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(99, 102, 241, 0.3);
}

.profile-status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8fafc;
  border-radius: 18px;
  padding: 18px 20px;
  margin-bottom: 28px;
  flex-wrap: wrap;
  gap: 20px;
}

.status-item span {
  display: block;
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 6px;
}

.status-item h6 {
  margin: 0;
  font-weight: 700;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 600;
}

.status-success {
  background: #dcfce7;
  color: #166534;
}

.status-danger {
  background: #fee2e2;
  color: #991b1b;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  margin-right: 8px;
}
.modern-info-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.modern-info-box {
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  padding: 12px 14px;
}

.modern-info-box span {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.modern-info-box h6 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.5;
  word-break: break-word;
}

/* Tablet */
@media (max-width: 991px) {
  .modern-info-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Mobile */
@media (max-width: 767px) {
  .modern-info-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .modern-info-box {
    padding: 10px 12px;
    border-radius: 12px;
  }

  .modern-info-box span {
    font-size: 10px;
    margin-bottom: 3px;
  }

  .modern-info-box h6 {
    font-size: 13px;
  }
}
.section-divider {
  margin-top: 35px;
  margin-bottom: 20px;
  position: relative;
  text-align: center;
}

.section-divider::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
  background: #e2e8f0;
}

.section-divider span {
  position: relative;
  background: white;
  padding: 0 16px;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
}

.address-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 18px;
}

.address-card {
  background: #f8fafc;
  border-radius: 18px;
  padding: 20px;
}
.address-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #eef2ff;
  color: #6366f1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modern-experience-card {
  border-radius: 26px;
  padding: 10px;
  background: #ffffff;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.06);
}

.experience-wrapper {
  position: relative;
}

.experience-item {
  display: flex;
  position: relative;
  margin-bottom: 35px;
}

.timeline-column {
  width: 40px;
  position: relative;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
}

.timeline-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  position: relative;
  z-index: 2;
  box-shadow: 0 0 0 6px #eef2ff;
}

.timeline-line {
  position: absolute;
  top: 18px;
  width: 2px;
  height: calc(100% + 35px);
  background: #e2e8f0;
}

.experience-content {
  flex: 1;
  background: #f8fafc;
  border-radius: 24px;
  padding: 24px;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.experience-top {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 20px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.company-info {
  display: flex;
  align-items: center;
}

.company-logo {
  width: 58px;
  height: 58px;
  border-radius: 18px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
  margin-right: 16px;
  flex-shrink: 0;
}

.designation {
  margin-bottom: 4px;
  font-weight: 700;
  color: #0f172a;
}

.company-name {
  margin-bottom: 0;
  color: #6366f1;
  font-weight: 600;
}

.duration-badge {
  background: #eef2ff;
  color: #6366f1;
  padding: 10px 16px;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 700;
}

.experience-date {
  display: inline-flex;
  align-items: center;
  background: white;
  padding: 10px 14px;
  border-radius: 14px;
  color: #64748b;
  font-size: 13px;
  margin-bottom: 18px;
  border: 1px solid #e2e8f0;
}

.experience-description {
  color: #475569;
  line-height: 1.8;
  margin-bottom: 18px;
  font-size: 14px;
}

.experience-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.experience-tag {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  padding: 8px 14px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 600;
}

.experience-tag.light {
  background: #e2e8f0;
  color: #475569;
}

.empty-experience {
  text-align: center;
  padding: 60px 20px;
}

.empty-icon {
  width: 80px;
  height: 80px;
  border-radius: 24px;
  background: #eef2ff;
  color: #6366f1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.empty-experience h5 {
  font-weight: 700;
  margin-bottom: 10px;
  color: #0f172a;
}

.empty-experience p {
  color: #94a3b8;
  max-width: 400px;
  margin: auto;
}
.modern-achievement-card {
  border-radius: 18px;
  padding: 10px;
  background: #fff;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);
}

.achievement-list {
  margin: 0;
  padding-left: 18px;
}

.achievement-list li {
  color: #475569;
  line-height: 1.7;
  margin-bottom: 6px;
  font-size: 14px;
}

.achievement-list li:last-child {
  margin-bottom: 0;
}
.modern-education-card {
  border-radius: 26px;
  padding: 10px;
  background: #ffffff;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.06);
}

.education-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 22px;
}

.education-item {
  background: #f8fafc;
  border-radius: 24px;
  padding: 24px;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  position: relative;
  overflow: hidden;
}

.education-top {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 20px;
}

.education-logo {
  width: 62px;
  height: 62px;
  border-radius: 20px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 10px 25px rgba(99, 102, 241, 0.25);
}

.running-badge {
  background: #dcfce7;
  color: #166534;
  padding: 8px 14px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 700;
}

.education-institute {
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 10px;
  line-height: 1.5;
}

.education-degree {
  color: #6366f1;
  font-weight: 600;
  margin-bottom: 22px;
  line-height: 1.6;
}

.education-subject {
  color: #475569;
}

.education-meta {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.meta-item {
  display: flex;
  align-items: center;
  background: white;
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid #eef2f7;
}

.meta-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #eef2ff;
  color: #6366f1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.meta-item span {
  color: #475569;
  font-size: 14px;
}

.meta-item b {
  color: #0f172a;
}

.empty-education {
  text-align: center;
  padding: 60px 20px;
}

.empty-education-icon {
  width: 90px;
  height: 90px;
  border-radius: 28px;
  background: #eef2ff;
  color: #6366f1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 22px;
}

.empty-education h5 {
  font-weight: 700;
  margin-bottom: 10px;
  color: #0f172a;
}

.empty-education p {
  color: #94a3b8;
  max-width: 420px;
  margin: auto;
  line-height: 1.7;
}
.modern-training-card {
  border-radius: 26px;
  padding: 10px;
  background: #ffffff;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.06);
}

.training-item {
  background: #f8fafc;
  border-radius: 24px;
  padding: 24px;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  position: relative;
  overflow: hidden;
}

.training-top {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 20px;
}

.running-badge {
  background: #dcfce7;
  color: #166534;
  padding: 8px 14px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 700;
}

.training-institute {
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 10px;
  line-height: 1.5;
}

.training-course {
  color: #6366f1;
  font-weight: 600;
  margin-bottom: 22px;
  line-height: 1.6;
  font-size: 15px;
}

.training-meta {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.meta-item {
  display: flex;
  align-items: start;
  background: white;
  border-radius: 16px;
  padding: 14px;
  border: 1px solid #eef2f7;
}

.meta-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: #eef2ff;
  color: #6366f1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  flex-shrink: 0;
}

.meta-item small {
  display: block;
  color: #94a3b8;
  margin-bottom: 4px;
  font-size: 12px;
}

.meta-item h6 {
  margin-bottom: 0;
  color: #0f172a;
  font-weight: 600;
  line-height: 1.5;
}

.training-footer {
  margin-top: 22px;
  display: flex;
  justify-content: flex-end;
}

.certificate-badge {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  padding: 9px 16px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 700;
}

.empty-training {
  text-align: center;
  padding: 60px 20px;
}

.empty-training-icon {
  width: 90px;
  height: 90px;
  border-radius: 28px;
  background: #eef2ff;
  color: #6366f1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 22px;
}

.empty-training h5 {
  font-weight: 700;
  margin-bottom: 10px;
  color: #0f172a;
}

.empty-training p {
  color: #94a3b8;
  max-width: 420px;
  margin: auto;
  line-height: 1.7;
}
.modern-portfolio-card {
  border-radius: 26px;
  padding: 10px;
  background: #ffffff;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.06);
}

.portfolio-project-item {
  background: #f8fafc;
  border-radius: 24px;
  padding: 26px;
  margin-bottom: 22px;
  border: 1px solid #eef2f7;
}

.portfolio-project-item:last-child {
  margin-bottom: 0;
}

.portfolio-top {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 20px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.portfolio-left {
  display: flex;
  align-items: start;
}

.portfolio-icon {
  width: 62px;
  height: 62px;
  border-radius: 20px;
  background: linear-gradient(135deg, #0ea5e9, #6366f1);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
  flex-shrink: 0;
}

.portfolio-title {
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
  line-height: 1.5;
}

.portfolio-subtitle {
  color: #64748b;
  margin-bottom: 0;
  line-height: 1.7;
  font-size: 14px;
}

.portfolio-status {
  background: #dcfce7;
  color: #166534;
  padding: 9px 16px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.portfolio-date {
  display: inline-flex;
  align-items: center;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 10px 14px;
  color: #64748b;
  font-size: 13px;
  margin-bottom: 18px;
}

.portfolio-link-wrapper {
  margin-bottom: 20px;
}

.portfolio-link {
  display: inline-flex;
  align-items: center;
  background: #eef2ff;
  color: #6366f1;
  padding: 10px 16px;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  word-break: break-all;
}

.portfolio-link:hover {
  text-decoration: none;
  color: #6366f1;
}

.portfolio-description {
  background: white;
  border-radius: 18px;
  padding: 20px;
  border: 1px solid #eef2f7;
  color: #475569;
  line-height: 1.8;
  margin-bottom: 22px;
}

.portfolio-description p:last-child {
  margin-bottom: 0;
}

.portfolio-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.portfolio-tag {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  padding: 9px 16px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 700;
}

.portfolio-tag.light {
  background: #e2e8f0;
  color: #475569;
}

.empty-portfolio {
  text-align: center;
  padding: 60px 20px;
}

.empty-portfolio-icon {
  width: 90px;
  height: 90px;
  border-radius: 28px;
  background: #eef2ff;
  color: #6366f1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 22px;
}

.empty-portfolio h5 {
  font-weight: 700;
  margin-bottom: 10px;
  color: #0f172a;
}

.empty-portfolio p {
  color: #94a3b8;
  max-width: 420px;
  margin: auto;
  line-height: 1.7;
}
.modern-curriculum-card {
  border-radius: 26px;
  padding: 10px;
  background: #ffffff;
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.06);
}
.curriculum-card-item {
  background: #f8fafc;
  border-radius: 16px;
  padding: 14px;
  border: 1px solid #eef2f7;
  height: 100%;
}

.curriculum-card-top {
  margin-bottom: 10px;
}

.curriculum-type-badge {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 30px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.3;
}

.badge-extra {
  background: #eef2ff;
  color: #6366f1;
}

.badge-co {
  background: #dcfce7;
  color: #166534;
}

.curriculum-card-title-text {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 10px;
  line-height: 1.5;
}

.curriculum-date-box {
  display: inline-flex;
  align-items: center;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 6px 10px;
  color: #64748b;
  font-size: 11px;
  margin-bottom: 10px;
}

.curriculum-description-box {
  background: white;
  border-radius: 12px;
  padding: 10px 12px;
  border: 1px solid #eef2f7;
  color: #475569;
  line-height: 1.6;
  font-size: 12px;
}

.curriculum-description-box p:last-child {
  margin-bottom: 0;
}

/* MOBILE */
@media (max-width: 767px) {
  .curriculum-card-item {
    padding: 10px;
    border-radius: 12px;
  }

  .curriculum-card-title-text {
    font-size: 13px;
  }

  .curriculum-description-box {
    font-size: 11px;
    padding: 8px 10px;
  }
}

.empty-curriculum {
  text-align: center;
  padding: 60px 20px;
}

.empty-curriculum-icon {
  width: 90px;
  height: 90px;
  border-radius: 28px;
  background: #eef2ff;
  color: #6366f1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 22px;
}

.empty-curriculum h5 {
  font-weight: 700;
  margin-bottom: 10px;
  color: #0f172a;
}

.empty-curriculum p {
  color: #94a3b8;
  max-width: 420px;
  margin: auto;
  line-height: 1.7;
}
</style>
